import React from "react";
import styles from "./ListPageShell.module.scss";

/**
 * Liste sayfası sarmalı — sabit dış ölçüleri tek noktadan yönetir.
 *
 *   <ListPageShell inspectorOpen={...} inspectorWidth="480px">
 *     <TableToolbar ... />
 *     <ListPageContent>
 *       <Table .../>
 *     </ListPageContent>
 *   </ListPageShell>
 *
 * - Sayfa background `--ds-surface`, içerik kartları `--ds-bg`.
 * - Inspector açıkken sağdan inspector genişliği kadar padding.
 * - Mobil/tablet/desktop padding token-driven (docs/DESIGN.md).
 */
const ListPageShell = ({
  as: Tag = "section",
  inspectorOpen,
  inspectorWidth = "480px",
  children,
  className,
}) => (
  <Tag
    className={[
      styles.shell,
      inspectorOpen ? styles.shellInspectorOpen : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
    style={{ "--list-inspector-width": inspectorWidth }}
  >
    {children}
  </Tag>
);

const ListPageContent = ({ children, className, ...rest }) => (
  <div className={`${styles.content} ${className || ""}`} {...rest}>
    {children}
  </div>
);

ListPageShell.Content = ListPageContent;

export default ListPageShell;
